import React from 'react';
import styled from 'styled-components';

class Mancheta extends React.Component {
  render() {
    const Bloque = styled.div`
      display: inline-block;
      margin-top: 2vw;
      cursor: pointer;
    `;

    const Logo = styled.img`
      width: auto;
      height: 26px;
      margin-top: 10px;
    `;

    return (
      <Bloque>
        <a href={this.props.referrer.u} alt={this.props.referrer.n} target="_blank">
        <Logo src={`./manchetas/negro/${this.props.referrer.r}.svg`} alt={this.props.referrer.n} />
        </a>
      </Bloque>
    );
  }
}

export default Mancheta;



// WEBPACK FOOTER //
// ./src/components/Mancheta.js